import { InjectionToken, Signal } from '@angular/core';

import { Observable } from 'rxjs';

import {
  CreateRequestReq,
  CreateRequestRes,
  GetCoursesReq,
  GetFinancialCategoriesRes,
  GetLocationsRes,
  GetRequestIdHashRes,
  SaveRequestEncryptedData,
  SupportRequest,
} from '../../../models';

export interface SupportFormApi {
  isLoading: Signal<boolean>;

  getCourses(): Observable<GetCoursesReq>;

  getLocations(): Observable<GetLocationsRes>;

  sendRequest(payload: SupportRequest): Observable<unknown>;

  getFinancialRequestIdHash(): Observable<GetRequestIdHashRes>;

  getFinancialCategories(): Observable<GetFinancialCategoriesRes>;

  createFinancialRequest(payload: CreateRequestReq): Observable<CreateRequestRes>;

  saveRequestEncryptedData(payload: SaveRequestEncryptedData): Observable<SaveRequestEncryptedData>;
}

export const SUPPORT_FORM_API = new InjectionToken<SupportFormApi>('SUPPORT_FORM_API');
